import { useMemo } from 'react'

import { useSchedulePostForm } from 'src/hook/useSchedulePostForm'
import { DayjsUtils } from 'src/utils/dayjs'
import {
  DATE_FORMAT_BRAZIL,
  DATE_FORMAT_IST,
  TIME_FORMAT_IST
} from 'src/pages/CommunityDetails/SchedulePostForm/constants'

export const useMinTime = () => {
  const { formData } = useSchedulePostForm()

  const minTime = useMemo(() => {
    try {
      DayjsUtils.setDefaultTz(formData.scheduledPubTimeZoneId)

      const currentDateTimeInTz = DayjsUtils.getCurrentDateTimeInTz(formData.scheduledPubTimeZoneId)
      const scheduledPubDate = DayjsUtils.dayjs.tz(
        formData.scheduledPubDate,
        DATE_FORMAT_BRAZIL,
        formData.scheduledPubTimeZoneId
      )

      const minTimeSpanHours = 2

      if (scheduledPubDate.utc(true).date() === currentDateTimeInTz.utc().date()) {
        const d = currentDateTimeInTz
          .add(minTimeSpanHours, 'hour')
          .tz(formData.scheduledPubTimeZoneId)
        return DayjsUtils.convertDateTimeToTz({
          date: d.format(DATE_FORMAT_IST),
          time: d.format(TIME_FORMAT_IST),
          tz: formData.scheduledPubTimeZoneId
        }).format('H:mm:ss')
      }
    } catch {
      return undefined
    }

    return undefined
  }, [formData.scheduledPubDate, formData.scheduledPubTimeZoneId])

  return minTime
}
